import React from "react";
import "./Loading.scss";

const Loading = (props) => {
  return (
    <div className="loading">
      <img src="/assets/loader.gif" alt="" />
    </div>
  );
};

export default Loading;
